import React from 'react'
import Popover from 'pcln-popover'
import { Flex, IconButton, Text } from 'pcln-design-system'
import { Close, InformationOutline } from 'pcln-icons'
import styled from 'styled-components'
import FocusLock from 'react-focus-lock'

const MontserratText = styled(Text.p)`
  // Popover doesn't apply font-family rule to <Text/> in renderContent
  font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
`

const AbsolutePosBtn = styled(IconButton)`
  top: 20px;
  right: 20px;
  position: absolute;
`

const InfoButton = styled(IconButton)`
  &&& {
    background-color: transparent;
    color: inherit;
    padding: 0;
  }
`

// z-index should be > that of <Footer />
const Z_INDEX = 2000

function FooterHintContent({ handleClose }) {
  function stopPropagation(e) {
    e.stopPropagation()
  }

  return (
    <FocusLock>
      <Flex flexDirection='column' p={2} onClick={stopPropagation}>
        <MontserratText fontSize={1} mb={1} mt={0} fontWeight='bold'>
          Tip:
        </MontserratText>
        <MontserratText mt={0} mb={1}>
          Use arrow keys to navigate the calendar
        </MontserratText>
        <AbsolutePosBtn onClick={handleClose} title='Close tooltip' icon={<Close />} />
      </Flex>
    </FocusLock>
  )
}

/** @public */
function FooterHint() {
  return (
    <Popover
      renderContent={FooterHintContent}
      placement='top'
      ariaLabel='Calendar navigation tooltip'
      overlayOpacity={0.3}
      width={350}
      borderColor='borderGray'
      zIndex={Z_INDEX}
      idx='date-picker-footer'
    >
      <InfoButton
        icon={<InformationOutline color='text.light' size={20} />}
        title='Navigation tip'
        type='button'
      />
    </Popover>
  )
}

export default FooterHint
